import type { PropsWithChildren } from "react"
import VehiclePageHeader from "./VehiclePageHeader"

interface VehiclePageLayoutProps extends PropsWithChildren {
  vin: string
}

/** Shared shell for vehicle sub-pages: header + `.page-content`-padded body,
 * so pages can't drift out of alignment with each other. */
export default function VehiclePageLayout({
  vin,
  children,
}: VehiclePageLayoutProps) {
  return (
    <main>
      <VehiclePageHeader vin={vin} />
      <div className="page-content">{children}</div>
    </main>
  )
}
